import { v4 as uuidv4 } from "uuid";
import type { RootBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { uploadStaticImage } from "../../../utils/uploadStaticImage";
import { defaultData as onboardingDefaultData } from "./OnboardingBlock/defaultData";
import OnboardingImage1 from "./OnboardingBlock/images/Onboarding1.png";
import OnboardingImage2 from "./OnboardingBlock/images/Onboarding2.png";
import OnboardingImage3 from "./OnboardingBlock/images/Onboarding3.png";

export const ONBOARDING_ROOT_BLOCK_TYPE = "onboarding" as const;

const initializeTemplateImages = async () => {
  const [onboarding1Upload, onboarding2Upload, onboarding3Upload] =
    await Promise.all([
      uploadStaticImage(OnboardingImage1, "onboarding1.png"),
      uploadStaticImage(OnboardingImage2, "onboarding2.png"),
      uploadStaticImage(OnboardingImage3, "onboarding3.png"),
    ]);

  return {
    onboarding1Upload,
    onboarding2Upload,
    onboarding3Upload,
  };
};

export const templateData = initializeTemplateImages();

const createBaseBlock = (
  name: string,
  order: number,
  headline: string,
  subtitle: string,
  buttonText: string,
  staticImage: string,
): RootBlock => ({
  id: uuidv4(),
  type: "root",
  meta: {
    name,
    nameI18n: name.toLowerCase(),
    type: ONBOARDING_ROOT_BLOCK_TYPE,
    order,
  },
  props: {
    children: {
      prop: "children",
      type: "children",
      value: [
        {
          ...onboardingDefaultData,
          id: uuidv4(),
          props: {
            ...onboardingDefaultData.props,
            headline: {
              prop: "other",
              type: "string",
              value: headline,
            },
            subtitle: {
              prop: "other",
              type: "string",
              value: subtitle,
            },
            buttonText: {
              prop: "other",
              type: "string",
              value: buttonText,
            },
            image: {
              prop: "other",
              type: "circle-image-upload",
              value: { url: staticImage, signed_id: "" },
            },
          },
        },
      ],
    },
  },
});

export const Screen1RootBlock = createBaseBlock(
  "Screen 1",
  0,
  "Join in the fun!",
  "Welcome users with your key message.",
  "Next",
  OnboardingImage1,
);

export const Screen2RootBlock = createBaseBlock(
  "Screen 2",
  1,
  "Level up with one of our courses",
  "Showcase available courses, regular events, or value of membership.",
  "Next",
  OnboardingImage2,
);

export const Screen3RootBlock = createBaseBlock(
  "Screen 3",
  2,
  "Learn anywhere",
  "Engage with our powerful community, learning alongside people like you",
  "Let's go!",
  OnboardingImage3,
);

void templateData.then(
  ({ onboarding1Upload, onboarding2Upload, onboarding3Upload }) => {
    Screen1RootBlock.props.children.value[0].props.image.value = {
      url: onboarding1Upload.url,
      signed_id: onboarding1Upload.signed_id,
    };

    Screen2RootBlock.props.children.value[0].props.image.value = {
      url: onboarding2Upload.url,
      signed_id: onboarding2Upload.signed_id,
    };

    Screen3RootBlock.props.children.value[0].props.image.value = {
      url: onboarding3Upload.url,
      signed_id: onboarding3Upload.signed_id,
    };
  },
);
